import Wix from 'wix-sdk';
import {createHttpClient, RequestOptions} from '@wix/http-client';

export const fetchDgs = (config: RequestOptions) => {
  return createHttpClient().request({
    ...config,
    params: {
      ...config.params,
      // TODO: Replace with WixSdk after merge https://github.com/wix-private/fed-infra/pull/2428
      commonConfig: JSON.stringify(Wix.Utils.commonConfig.getAll()),
    },
  });
};
